module.exports = __webpack_public_path__ + "static/img/celoscope-detail-17.5d7ea66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-17.jpg
// module id = TLeH
// module chunks = 52